var _excluded = ["className", "variant", "size", "shape", "asChild", "loading"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from "../lib/utils";
var buttonVariants = cva('inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background', {
  variants: {
    variant: {
      default: 'bg-primary text-primary-foreground hover:bg-primary/90',
      primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
      'primary-glowing': 'bg-primary text-primary-foreground hover:bg-primary/90',
      destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
      outline: 'border border-input dark:border-grey-300 bg-background hover:bg-accent hover:text-accent-foreground',
      'outline-color': 'border border-primary-700 text-primary-500 bg-background hover:bg-[rgba(224,79,22,0.15)] hover:text-primary-400',
      secondary: 'bg-primary-50 dark:bg-popover-hover hover:dark:bg-hover dark:text-primary-foreground text-primary-700 hover:bg-primary-100 hover:text-primary-800 dark:border-grey-400 ',
      'secondary-gray': 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 hover:text-gray-800',
      ghost: 'text-gray-500 hover:bg-gray-50 hover:text-gray-600',
      'ghost-color': 'text-primary-700 hover:bg-primary-50 hover:text-primary-800',
      link: 'text-gray-500 dark:text-foreground hover:text-gray-600',
      'link-color': 'text-primary-700 hover:text-primary-800 dark:text-primary-500 dark:hover:text-primary-400'
    },
    size: {
      default: 'h-10 px-4',
      sm: 'h-9 px-[14px]',
      md: 'h-10 px-4',
      lg: 'h-11 px-[18px] text-md',
      xl: 'h-12 px-5 text-md',
      '2xl': 'h-[60px] px-7 text-lg'
    },
    shape: {
      default: '',
      square: '',
      circle: ''
    }
  },
  compoundVariants: [{
    shape: 'square',
    size: 'default',
    class: 'px-[10px] py-[10px]'
  }, {
    shape: 'square',
    size: 'sm',
    class: 'px-[8px] py-[8px]'
  }, {
    shape: 'square',
    size: 'md',
    class: 'px-[10px] py-[10px]'
  }, {
    shape: 'square',
    size: 'lg',
    class: 'px-[12px] py-[12px]'
  }, {
    shape: 'square',
    size: 'xl',
    class: 'px-[14px] py-[14px]'
  }, {
    shape: 'square',
    size: '2xl',
    class: 'px-[16px] py-[16px]'
  }, {
    variant: 'primary-glowing',
    size: 'sm',
    class: 'shadow-[0px_0px_20px_-4px_rgba(207,92,16,0.50)]'
  }, {
    variant: 'primary-glowing',
    size: 'default',
    class: 'shadow-[0px_0px_40px_-4px_rgba(207,92,16,0.50)]'
  }, {
    variant: 'primary-glowing',
    size: 'md',
    class: 'shadow-[0px_0px_40px_-4px_rgba(207,92,16,0.50)]'
  }, {
    variant: 'primary-glowing',
    size: 'lg',
    class: 'shadow-[0px_0px_60px_-4px_rgba(207,92,16,0.50)]'
  }, {
    variant: 'primary-glowing',
    size: 'xl',
    class: 'shadow-[0px_0px_60px_-4px_rgba(207,92,16,0.50)]'
  }, {
    variant: 'primary-glowing',
    size: '2xl',
    class: 'shadow-[0px_0px_60px_-4px_rgba(207,92,16,0.50)]'
  }],
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    variant = _ref.variant,
    size = _ref.size,
    shape = _ref.shape,
    asChild = _ref.asChild,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    props = _objectWithoutProperties(_ref, _excluded);
  var Comp = asChild ? Slot : 'button';
  return /*#__PURE__*/React.createElement(Comp, _extends({
    className: cn(buttonVariants({
      variant: variant,
      size: size,
      className: className,
      shape: shape
    })),
    ref: ref,
    disabled: loading || props.disabled
  }, props), /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(Loader2, {
    className: "mr-2 h-4 w-4 animate-spin"
  }) : null, props.children));
});
Button.displayName = 'Button';
export { Button, buttonVariants };